import authReducer from "slices/auth";
import { combineReducers } from "redux";
import jobsReducer from "slices/jobs";

export default combineReducers({
  auth: authReducer,
  jobs: jobsReducer,
});
